import { AxiosError } from 'axios';
import { ServerError, ServerErrorsBySource } from '../interfaces/errors';

export function errorParser(
  error: AxiosError<{ errors: ServerError[] } | string>
): ServerErrorsBySource {
  if (!error.response) {
    return {
      base: { status: '422', detail: 'An unexpected error has occurred' }
    };
  }

  // If the error's 'response.data' is a string, it means the 'response.data' is not one of
  // our 'ServerError's, e.g. for a 404, 'response.data' would be an empty string.
  if (typeof error.response.data === 'string') {
    return {
      base: {
        status: String(error.response.status),
        detail: error.response.statusText
      }
    };
  }

  const errors = error.response.data.errors || [];
  return Object.fromEntries(
    errors.map(e => {
      let source = 'base';
      if (e.source?.pointer) {
        source = e.source.pointer.replace('/data/attributes/', '');
      } else if (e.source?.parameter) {
        source = e.source.parameter;
      }

      return [source, e];
    })
  );
}
